var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"all-layout"},[_c('h2',[_vm._v("All Layout")]),_c('MenuBar',{staticClass:"m-4"}),_c('router-view')],1)}
var staticRenderFns = []

export { render, staticRenderFns }